import * as React from 'react'

import * as styles from './showMore.module.css'

interface IProps {
  toggleCollapsed: React.EventHandler<any>
  collapsed: boolean
}

const ShowMore = ({ toggleCollapsed, collapsed }: IProps) => {
  return (
    <div role="button" onClick={toggleCollapsed} className={styles.root}>
      Show {collapsed ? 'more' : 'less'}
    </div>
  )
}

export default ShowMore
